import { Component } from 'react'
import FreeNavSlider from 'components/FreeNavSlider'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { ProductNameHOC } from 'hocs'
import { selectDevices, selectIsFetching } from './selectors'

class FreeNavSliderContainer extends Component {
  handleClick = (device) => {
    browserHistory.push(`/faq/${device.faqPk}?device=${device.id}`)
  }

  render() {
    const props = {
      ...this.props,
      handleClick: this.handleClick
    }

    return <FreeNavSlider {...props} />
  }
}

const mapStateToProps = (state) => ({
  devices: selectDevices(state),
  isFetching: selectIsFetching(state)
})

export default connect(mapStateToProps)(ProductNameHOC(FreeNavSliderContainer))
